module.exports = __webpack_public_path__ + "img/corner-up-left.5d9fb605.svg";